var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-single") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,3A11,11,0,1,0,35,14,11,11,0,0,0,24,3Zm0,18a7,7,0,1,1,7-7A7,7,0,0,1,24,21ZM41.1,34A31.3,31.3,0,0,0,24,29,32.1,32.1,0,0,0,6.9,33.9l-.9.6V43a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V34.5ZM38,41H10V36.7A28.4,28.4,0,0,1,24,33a27.5,27.5,0,0,1,14,3.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.76acc8be99999abb9b8dcd3aa2256127.svg";
export { ForwardRef as ReactComponent };